import { Checkbox, DataSource, Layout, LayoutHeader, Panel, SearchButton, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutAuditLogQuery extends Layout {
    checkboxAuditLog: Checkbox;
    checkboxAuditLogTx: Checkbox;
    checkboxInserts: Checkbox;
    layoutHeaderAuditLogQuery: LayoutHeader;
    panelFilter: Panel;
    searchbuttonSearchbutton1: SearchButton;
    sourceAuditLog: DataSource;
    tableAuditLogQuery: Table;
    textboxEndDateTime: Textbox;
    textboxStartDateTime: Textbox;
    textboxTable: Textbox;
    textboxUserId: Textbox;
}
